export default __webpack_public_path__ + "static/media/f1.30c0b5e1.jfif";